// export const getGmailSignedUrl = async () => {
//   try {
//     const res = await axios.get(`${apiUrl}/youtube/gmail-signed-url`)
//     return res.data
//   } catch (error) {
//     return errorMiddleware(error)
//   }
// }

import { client, ClientMethodsTypes } from "@/services/v2/client"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { UserQueryKeys } from "containers/user/types/user"
import { useGoogleConnectedStatus } from "./connect-gmail"
import { DealSyncContactResponse } from "../types/deal-sync"
import { useMemo } from "react"

const baseUrl = `/api/v1/dealsync`


export const useDelSyncStatus = () => {
  const { data } = useGoogleConnectedStatus()

  return useQuery({
    queryKey: [UserQueryKeys.CONNECTIONS, 'processing-status-by-id'],
    queryFn: () => {
      return client<boolean>(`${baseUrl}/processing-status-by-id`)
    },
    enabled: !!data?.gmailConnected,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchIntervalInBackground: true,
  })
}

export const useDelSyncContacts = () => {
  const { data } = useGoogleConnectedStatus()
  const { data: status } = useDelSyncStatus()

  const {data: dataContacts, ...rest} = useQuery({
    queryKey: [UserQueryKeys.CONNECTIONS, 'identified-contacts-by-id'],
    queryFn: () => {
      return client<DealSyncContactResponse>(`${baseUrl}/identified-contacts-by-id`)
    },
    enabled: !!data?.gmailConnected,
    refetchInterval: status ? 5000 : false,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchIntervalInBackground: true,
  })

  const contacts = useMemo(() => {
    if (!dataContacts) return []

    // Filters contacts methods
    const cleanName = (name: string) =>
      name?.replace(/"/g, '').trim() ?? ''
  
    const countWords = (name: string) =>
      cleanName(name).split(/\s+/).filter(Boolean).length

    return dataContacts
      .map(contact => ({
        ...contact,
        contactName: cleanName(contact.contactName),
      }))
      .filter(contact => {
        const name = contact.contactName
        const hasExactlyTwoWords = countWords(name) === 2
        const doesNotContainAtSymbol = !name.includes('@')
        return hasExactlyTwoWords && doesNotContainAtSymbol
      }) || []
  }, [dataContacts])

  return {
    data: contacts,
    ...rest,
  }
}

export const useDealSyncInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (emailString: string) => {
      return client(`/api/v1/users/connections/dealsync-invite-contacts`, {
        method: ClientMethodsTypes.POST,
        body: {
          emailString,
        },
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries([UserQueryKeys.CONNECTIONS, 'identified-contacts'])
    },
  })
}
